import { ApexOptions } from 'apexcharts';
import { useEffect, useMemo, useState } from 'react';

import { generateChartDataUri } from '../../../../../components/graphs';
import { END_POINTS } from '../../../../../services';
import { TEXT_CONTENT } from '../../../../../utils/constants';
import { toFixedDigit } from '../../../../../utils/number';
import useGraphApiData from '../../../useGraphApiData';
import { DOW_GRAPH_OPTIONS, createGraphData } from './DowVolumes.services';
import PdfDowVolume from './PdfDowVolume';

const graphOpt: ApexOptions = {
  ...DOW_GRAPH_OPTIONS,
  title: { text: TEXT_CONTENT.DOW_VOLUMES },
  chart: { ...DOW_GRAPH_OPTIONS.chart, height: 400 },
};
export const usePdfDowVolume = ({
  scenario,
  day,
}: {
  scenario: string;
  day: string | number;
}) => {
  const [graphUri, setGraphUri] = useState('');
  const { isLoading, data: apiResponse } = useGraphApiData(
    END_POINTS.DASHBOARD.geDowVolumesData(scenario)
  );

  const graphOptions = useMemo(() => {
    const val =
      Array.isArray(apiResponse) && apiResponse.length > 0
        ? toFixedDigit(
            apiResponse?.reduce?.((prev: number, curr: any) => {
              if (isNaN(Number(curr?.dow_volume))) return prev;
              return prev + curr?.dow_volume;
            }, 0) / apiResponse.length
          )
        : '';
    return createGraphData(apiResponse, {
      ...graphOpt,
      chart: {
        ...(graphOpt.chart || {}),
        height: 600,
      },
      subtitle: { text: `Overall Average : ${val}` },
    });
  }, [apiResponse]);

  useEffect(() => {
    const generateGraphUri = async () => {
      const res: any = await generateChartDataUri({
        ...graphOptions.options,
        series: [...graphOptions.data],
      });
      setGraphUri(res?.['imgURI'] || '');
    };
    generateGraphUri();
  }, [graphOptions.options, graphOptions.data]);

  return {
    renderer: PdfDowVolume({
      graphUri,
    }),
    isLoading,
  };
};
export default usePdfDowVolume;
